// extracted by mini-css-extract-plugin
export default {"root":"Button_root__loEnA","modal-open":"Button_modal-open__eFIk1","hidden-button":"Button_hidden-button__xru29","btn-auth":"Button_btn-auth__m+g-Q"};